import { Dispatch } from "redux"

export const SET_PURCHASE_PLAN_IDENTIFIERS = "SET_PURCHASE_PLAN_IDENTIFIERS"

export const PURCHASE_PLAN = "PURCHASE_PLAN"
export const PURCHASE_PLAN_SUCCESS = `${PURCHASE_PLAN}_SUCCESS`
export const PURCHASE_PLAN_FAILURE = `${PURCHASE_PLAN}_FAILURE`
export const PURCHASE_PLAN_CALL = `${PURCHASE_PLAN}_CALL`

export const PURCHASE_PLAN_INFO = "PURCHASE_PLAN_INFO"
export const PURCHASE_PLAN_INFO_SUCCESS = `${PURCHASE_PLAN_INFO}_SUCCESS`
export const PURCHASE_PLAN_INFO_FAILURE = `${PURCHASE_PLAN_INFO}_FAILURE`
export const PURCHASE_PLAN_INFO_CALL = `${PURCHASE_PLAN_INFO}_CALL`

export const EVENT_TYPE_OPTIONS = "EVENT_TYPE_OPTIONS"
export const EVENT_TYPE_OPTIONS_SUCCESS = `${EVENT_TYPE_OPTIONS}_SUCCESS`
export const EVENT_TYPE_OPTIONS_FAILURE = `${EVENT_TYPE_OPTIONS}_FAILURE`
export const EVENT_TYPE_OPTIONS_CALL = `${EVENT_TYPE_OPTIONS}_CALL`

export const PRICING_VARIABLES = "PRICING_VARIABLES"
export const PRICING_VARIABLES_RESET = `${PRICING_VARIABLES}_RESET`

export function setPurchasePlanIdentifiers(data: {
  productPrefixUrl: string
  productId: string
  purchasePlanId: string
}) {
  return (dispatch: Dispatch) => {
    return dispatch({ type: SET_PURCHASE_PLAN_IDENTIFIERS, payload: data })
  }
}

export function resetPricingVariables() {
  return (dispatch: Dispatch) => {
    return dispatch({ type: PRICING_VARIABLES_RESET })
  }
}
